import React from 'react';

import { cssMap } from '@compiled/react';

import { SmartCardProvider } from '@atlaskit/link-provider';
import { Box, Stack } from '@atlaskit/primitives/compiled';

import { parseDynamicLayoutOutputToJson } from './dynamic-layout-parser/dynamic-layout-parser';
import { DynamicLayoutSections } from './ui/section/dynamic-layout-sections';
import { getFirstFoldableSectionIdx } from './utils';

export type DynamicLayoutData = {
	data: string;
	fastAnswerData?: string;
};

interface DynamicLayoutBodyProps {
	contentToRender: string;
}

const styles = cssMap({
	containerStyles: {
		textAlign: 'left',
	},
});

export const DynamicLayout = ({ contentToRender }: DynamicLayoutBodyProps): React.JSX.Element => {
	const parsedAnswer = parseDynamicLayoutOutputToJson(contentToRender);

	const firstFoldableIndex = getFirstFoldableSectionIdx(parsedAnswer);

	return (
		<SmartCardProvider>
			<Box xcss={styles.containerStyles} testId="dynamic-layout-container">
				<Stack>
					{parsedAnswer &&
						parsedAnswer.length &&
						parsedAnswer.map((section, index) => {
							const isFoldable = section.attributes?.hasOwnProperty('folded');
							const defaultFoldedState = isFoldable
								? index === firstFoldableIndex
									? 'expanded'
									: 'collapsed'
								: undefined;

							return (
								// TODO: rename this component to be singular
								<DynamicLayoutSections
									key={index}
									section={section}
									defaultFoldedState={defaultFoldedState}
								/>
							);
						})}
				</Stack>
			</Box>
		</SmartCardProvider>
	);
};
